var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 299,
    viewBox: "0 0 116 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M112.983 292.608L103.464 297.763C104.802 297.038 105.63 295.495 105.641 293.303L115.16 288.148C115.155 290.34 114.321 291.883 112.983 292.608Z",
    fill: "url(#paint0_linear_7011_3)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.7334 5.62355L13.2527 0.468743C14.6071 -0.266928 16.488 -0.159644 18.5552 0.95408L9.03587 6.10888C6.96312 4.99516 5.08782 4.89298 3.7334 5.62355Z",
    fill: "url(#paint1_linear_7011_3)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M106.215 66.3775L105.64 293.301L115.153 288.147L115.735 61.2227L106.215 66.3775Z",
    fill: "url(#paint2_linear_7011_3)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.03711 6.10793L18.5565 0.953125L108.299 49.2264L98.7796 54.3761L9.03711 6.10793Z",
    fill: "url(#paint3_linear_7011_3)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M98.243 55.2528L8.50049 6.97952C7.50798 6.44309 6.53741 6.16211 5.69844 6.16211C3.7902 6.16211 2.64966 7.62834 2.64418 10.0857L2.06839 237.01C2.05742 241.091 5.15014 246.083 8.96115 248.131L98.7036 296.405C99.7015 296.941 100.672 297.222 101.511 297.222C103.414 297.222 104.56 295.756 104.565 293.299L105.141 66.3747C105.152 62.2928 102.059 57.3014 98.2485 55.2528H98.243Z",
    fill: "url(#paint4_linear_7011_3)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.7783 54.3755L108.298 49.2207C112.421 51.4379 115.744 56.8073 115.733 61.2162L106.214 66.371C106.225 61.957 102.902 56.5876 98.7783 54.3755Z",
    fill: "url(#paint5_linear_7011_3)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M98.7801 54.3789L9.03763 6.10563C4.91955 3.8884 1.56921 5.67138 1.55824 10.0803L0.982449 237.004C0.971482 241.418 4.29449 246.788 8.41258 249L98.155 297.273C102.279 299.49 105.623 297.712 105.64 293.298L106.216 66.3745C106.227 61.9604 102.904 56.591 98.7801 54.3789ZM104.554 293.298C104.549 295.756 103.403 297.222 101.5 297.222C100.661 297.222 99.6849 296.941 98.6924 296.404L8.94995 248.131C5.13894 246.083 2.04622 241.091 2.05719 237.009L2.63298 10.0854C2.63846 7.62806 3.78448 6.16183 5.68724 6.16183C6.52621 6.16183 7.49678 6.44281 8.48929 6.97924L98.2318 55.2525C102.048 57.3063 105.141 62.2925 105.125 66.3745L104.549 293.298H104.554Z",
    fill: "url(#paint6_linear_7011_3)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M87.8683 83.1151L18.2611 45.6726C17.4879 45.2587 16.7367 45.0391 16.0842 45.0391C14.6036 45.0391 13.7208 46.1783 13.7153 48.0839L13.2657 224.093C13.2547 227.261 15.6565 231.128 18.612 232.717L88.2192 270.159C88.9924 270.573 89.7436 270.793 90.3962 270.793C91.8767 270.793 92.7595 269.654 92.765 267.748L93.2147 91.7388C93.2256 88.5714 90.8239 84.704 87.8683 83.11V83.1151Z",
    fill: "url(#paint7_linear_7011_3)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.877 105.793L22.7099 103.719C23.2089 103.448 23.8998 103.489 24.6675 103.898L20.8345 105.972C20.0723 105.563 19.3814 105.522 18.877 105.793Z",
    fill: "url(#paint8_linear_7011_3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3193 150.521L79.4863 152.595C79.9798 152.329 80.287 151.762 80.287 150.955L84.1199 148.881C84.1199 149.688 83.8128 150.255 83.3193 150.521Z",
    fill: "url(#paint9_linear_7011_3)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M80.318 140.91L84.151 138.836L84.1181 148.88L80.2852 150.954L80.318 140.91Z",
    fill: "url(#paint10_linear_7011_3)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.835 105.973L24.6679 103.898L81.4108 134.419L77.5779 136.493L20.835 105.973Z",
    fill: "url(#paint11_linear_7011_3)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5762 136.492L81.4091 134.418C82.928 135.235 84.1508 137.212 84.1454 138.837L80.3124 140.911C80.3124 139.287 79.0896 137.31 77.5762 136.492Z",
    fill: "url(#paint12_linear_7011_3)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M77.576 136.489C79.0949 137.307 80.3177 139.284 80.3123 140.909L80.2794 150.953C80.2794 152.577 79.0401 153.231 77.5212 152.414L20.7783 121.894C19.2593 121.076 18.0365 119.099 18.042 117.474L18.0749 107.43C18.0749 105.806 19.3142 105.152 20.8331 105.969L77.576 136.489Z",
    fill: "url(#paint13_linear_7011_3)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3827 129.688L22.251 113.483V112.344L52.3827 128.549V129.688Z",
    fill: "#9A9AED"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3827 131.891L22.251 115.68V114.541L52.3827 130.751V131.891Z",
    fill: "#9A9AED"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.3827 134.087L22.251 117.881V116.742L52.3827 132.947V134.087Z",
    fill: "#9A9AED"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0995 151.872L21.9678 135.667V134.527L52.0995 150.738V151.872Z",
    fill: "#9A9AED"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0995 154.073L21.9678 137.863V136.729L52.0995 152.934V154.073Z",
    fill: "#9A9AED"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0995 156.27L21.9678 140.065V138.926L52.0995 155.136V156.27Z",
    fill: "#9A9AED"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0995 175.071L21.9678 158.866V157.727L52.0995 173.937V175.071Z",
    fill: "#9A9AED"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0995 177.272L21.9678 161.062V159.928L52.0995 176.133V177.272Z",
    fill: "#9A9AED"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0995 179.469L21.9678 163.264V162.125L52.0995 178.335V179.469Z",
    fill: "#9A9AED"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.877 128.85L22.7099 126.776C23.2089 126.505 23.8998 126.546 24.6675 126.954L20.8345 129.029C20.0723 128.62 19.3814 128.579 18.877 128.85Z",
    fill: "url(#paint14_linear_7011_3)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3193 173.577L79.4863 175.652C79.9798 175.386 80.287 174.819 80.287 174.012L84.1199 171.938C84.1199 172.745 83.8128 173.312 83.3193 173.577Z",
    fill: "url(#paint15_linear_7011_3)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M80.319 163.967L84.1519 161.893L84.1191 171.931L80.2861 174.011L80.319 163.967Z",
    fill: "url(#paint16_linear_7011_3)"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.835 129.028L24.6679 126.949L81.4108 157.474L77.5779 159.549L20.835 129.028Z",
    fill: "url(#paint17_linear_7011_3)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5762 159.549L81.4091 157.475C82.928 158.292 84.1508 160.269 84.1454 161.894L80.3124 163.968C80.3124 162.343 79.0896 160.366 77.5762 159.549Z",
    fill: "url(#paint18_linear_7011_3)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M77.576 159.548C79.0949 160.366 80.3177 162.343 80.3123 163.967L80.2794 174.011C80.2794 175.636 79.0401 176.29 77.5212 175.472L20.7783 144.952C19.2593 144.135 18.0365 142.158 18.042 140.533L18.0749 130.489C18.0749 128.864 19.3142 128.211 20.8331 129.028L77.576 159.548Z",
    fill: "url(#paint19_linear_7011_3)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M18.877 151.912L22.7099 149.838C23.2089 149.567 23.8998 149.608 24.6675 150.017L20.8345 152.091C20.0723 151.682 19.3814 151.642 18.877 151.912Z",
    fill: "url(#paint20_linear_7011_3)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3193 196.644L79.4863 198.718C79.9798 198.452 80.287 197.885 80.287 197.078L84.1199 195.004C84.1199 195.811 83.8128 196.378 83.3193 196.644Z",
    fill: "url(#paint21_linear_7011_3)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M80.318 187.037L84.151 184.963L84.1181 195.002L80.2852 197.081L80.318 187.037Z",
    fill: "url(#paint22_linear_7011_3)"
  }))), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8359 152.092L24.6689 150.018L81.4118 180.538L77.5789 182.617L20.8359 152.092Z",
    fill: "url(#paint23_linear_7011_3)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5771 182.615L81.4101 180.541C82.929 181.358 84.1518 183.336 84.1463 184.96L80.3134 187.034C80.3134 185.41 79.0906 183.433 77.5771 182.615Z",
    fill: "url(#paint24_linear_7011_3)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M77.576 182.613C79.0949 183.43 80.3177 185.407 80.3123 187.032L80.2794 197.076C80.2794 198.7 79.0401 199.354 77.5212 198.537L20.7783 168.017C19.2593 167.199 18.0365 165.222 18.042 163.597L18.0749 153.554C18.0749 151.929 19.3142 151.275 20.8331 152.092L77.576 182.613Z",
    fill: "url(#paint25_linear_7011_3)"
  }))), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7377 92.2187L25.2499 89.0503L24.3418 91.5576L21.44 89.8823L26.3949 76.8098L29.6125 78.6675L34.5674 97.4614L31.6458 95.7746L30.7377 92.2187ZM29.9876 89.2326L27.9938 81.4256L26 86.9304L29.9876 89.2326ZM39.1831 84.2158L39.1831 100.126L36.4194 98.5306L36.4194 82.6202L39.1831 84.2158Z",
    fill: "url(#paint26_linear_7011_3)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0232 69.2261L39.6014 74.0138L42.772 77.7739L39.6014 77.873L38.0232 80.8383L36.445 76.0506L33.2744 72.2905L36.445 72.1914L38.0232 69.2261Z",
    fill: "#ADC8F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7011_3",
    x1: 109.309,
    y1: 256.688,
    x2: 109.309,
    y2: 297.298,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7011_3",
    x1: -29.5129,
    y1: -34.588,
    x2: 12.6657,
    y2: 12.4875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#82A7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7011_3",
    x1: 110.684,
    y1: 76.9527,
    x2: 110.684,
    y2: 296.637,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7011_3",
    x1: 9.03711,
    y1: 27.6672,
    x2: 108.299,
    y2: 27.6672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7011_3",
    x1: 53.5965,
    y1: 332.79,
    x2: 53.5965,
    y2: -80.0953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7011_3",
    x1: 107,
    y1: 64.5001,
    x2: 102,
    y2: 52.5001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7011_3",
    x1: 53.5963,
    y1: 408.921,
    x2: 53.5963,
    y2: 144.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5F00BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#6005BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#6314C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#682DCE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6F50DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#797CED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7011_3",
    x1: 53.2457,
    y1: 298.386,
    x2: 53.2457,
    y2: -21.8661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7011_3",
    x1: 11.6169,
    y1: 95.3814,
    x2: 47.1618,
    y2: 133.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7011_3",
    x1: 81.8004,
    y1: 160.861,
    x2: 81.8004,
    y2: 136.497,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7011_3",
    x1: 82.2153,
    y1: 157.774,
    x2: 82.2153,
    y2: 141.002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7011_3",
    x1: 18.0548,
    y1: 89.3843,
    x2: 53.5999,
    y2: 127.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7011_3",
    x1: 80.8608,
    y1: 166.348,
    x2: 80.8608,
    y2: 141.984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_7011_3",
    x1: 18.042,
    y1: 129.194,
    x2: 80.3177,
    y2: 129.194,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5600AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5705AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5B14B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#612DC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6B50D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#767CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_7011_3",
    x1: 11.6169,
    y1: 118.433,
    x2: 47.1614,
    y2: 156.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_7011_3",
    x1: 81.8004,
    y1: 183.918,
    x2: 81.8004,
    y2: 159.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_7011_3",
    x1: 82.2163,
    y1: 180.831,
    x2: 82.2163,
    y2: 164.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_7011_3",
    x1: 18.0548,
    y1: 112.44,
    x2: 53.5999,
    y2: 150.592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_7011_3",
    x1: 80.8608,
    y1: 189.4,
    x2: 80.8608,
    y2: 165.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_7011_3",
    x1: -705.304,
    y1: 152.248,
    x2: -704.756,
    y2: 152.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5600AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5705AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5B14B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#612DC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6B50D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#767CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_7011_3",
    x1: 11.6169,
    y1: 141.501,
    x2: 47.1614,
    y2: 179.657,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_7011_3",
    x1: 81.8004,
    y1: 206.984,
    x2: 81.8004,
    y2: 182.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_7011_3",
    x1: 82.2153,
    y1: 203.896,
    x2: 82.2153,
    y2: 187.129,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_7011_3",
    x1: 18.0558,
    y1: 135.503,
    x2: 53.6005,
    y2: 173.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_7011_3",
    x1: 80.8617,
    y1: 212.466,
    x2: 80.8617,
    y2: 188.107,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#020305"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#0A0D14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#171D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#293450"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#3F527D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5B76B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#7C9FF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_7011_3",
    x1: -705.304,
    y1: 175.312,
    x2: -704.756,
    y2: 175.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#5600AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#5705AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#5B14B6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#612DC2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#6B50D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#767CE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#82A7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_7011_3",
    x1: 33.2737,
    y1: 71.7144,
    x2: 18.0525,
    y2: 98.0782,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9C6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AFC9F0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationMain);
export default __webpack_public_path__ + "static/media/Illustration-main.0f916625e5878e146d66bacc8e6d8364.svg";
export { ForwardRef as ReactComponent };